import { COOKIE_CONSENT_COOKIE_NAME } from '@/components/CookieConsent/constants'

declare global {
  interface Window {
    aGTM?: {
      f?: {
        run_cc?: (action: 'init' | 'update') => boolean
      }
    }
  }
}

let lastConsentCookieValue: string | null = null

function readConsentCookieValue(): string | null {
  if (typeof document === 'undefined') return null

  const prefix = `${COOKIE_CONSENT_COOKIE_NAME}=`
  const cookies = document.cookie.split(';')

  for (const cookie of cookies) {
    const trimmed = cookie.trim()
    if (trimmed.startsWith(prefix)) {
      return trimmed.slice(prefix.length)
    }
  }

  return null
}

export function notifyAgtmConsentUpdate(): void {
  if (typeof window === 'undefined') return

  const cookieValue = readConsentCookieValue()
  if (!cookieValue) return
  if (cookieValue === lastConsentCookieValue) return

  const runCc = window.aGTM?.f?.run_cc
  if (typeof runCc !== 'function') return

  try {
    const didUpdate = runCc('update')
    if (didUpdate) {
      lastConsentCookieValue = cookieValue
    }
  } catch {
    // Retry on the next consent lifecycle call.
  }
}

export function resetAgtmConsentBridgeForTests(): void {
  lastConsentCookieValue = null
}
